module.exports = __webpack_public_path__ + "static/media/desert-light.5de2149e.svg";